import { render } from "./Headline.vue?vue&type=template&id=7800ea1b"
const script = {}

import "./Headline.vue?vue&type=style&index=0&id=7800ea1b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__